/* tslint:disable */
/* eslint-disable */
/**
 * Jobs API
 * Backend de bolsa de trabajo para alumno, empresa y admin.  Pantallas de Alumno [P_A_xx]   https://app.axure.cloud/app/project/5t0fsq/overview  Pantallas de empresa [P_E_xx]    https://app.axure.cloud/app/project/jcj3w8/overview
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    CompanyOfferItem,
    CompanyOfferItemFromJSON,
    CompanyOfferItemFromJSONTyped,
    CompanyOfferItemToJSON,
    Pagination,
    PaginationFromJSON,
    PaginationFromJSONTyped,
    PaginationToJSON,
} from './';

/**
 * Paginated data
 * @export
 * @interface CompanyPaginatedOfferItems
 */
export interface CompanyPaginatedOfferItems {
    /**
     * 
     * @type {Array<CompanyOfferItem>}
     * @memberof CompanyPaginatedOfferItems
     */
    data?: Array<CompanyOfferItem>;
    /**
     * 
     * @type {Pagination}
     * @memberof CompanyPaginatedOfferItems
     */
    pagination?: Pagination;
}

export function CompanyPaginatedOfferItemsFromJSON(json: any): CompanyPaginatedOfferItems {
    return CompanyPaginatedOfferItemsFromJSONTyped(json, false);
}

export function CompanyPaginatedOfferItemsFromJSONTyped(json: any, ignoreDiscriminator: boolean): CompanyPaginatedOfferItems {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : ((json['data'] as Array<any>).map(CompanyOfferItemFromJSON)),
        'pagination': !exists(json, 'pagination') ? undefined : PaginationFromJSON(json['pagination']),
    };
}

export function CompanyPaginatedOfferItemsToJSON(value?: CompanyPaginatedOfferItems | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': value.data === undefined ? undefined : ((value.data as Array<any>).map(CompanyOfferItemToJSON)),
        'pagination': PaginationToJSON(value.pagination),
    };
}


